import { createFileRoute } from '@tanstack/react-router'
import OffersComponent from './-components/component'

export const Route = createFileRoute('/(pharma)/_layout/offers/')({
  component: () => <OffersComponent />
})